import React, { useCallback, useMemo } from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoClose } from '../../node_modules/react-icons/io5/index.esm.js';
import ListView from '../ListView/index.js';
import { genericMemo } from '../../utils/index.js';
import Button from '../Button/index.js';
import styles from './styles.css.js';

var _IoClose;

function ListItem(props) {
  const {
    itemKey,
    datum,
    labelSelector,
    onRemove,
    disabled,
    readOnly,
    rendererClassName
  } = props;
  const label = labelSelector(datum);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.item, rendererClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, label), !readOnly && /*#__PURE__*/React.createElement(Button, {
    className: styles.removeButton,
    name: itemKey,
    onClick: onRemove,
    variant: "transparent",
    disabled: disabled
  }, _IoClose || (_IoClose = /*#__PURE__*/React.createElement(IoClose, null))));
}

function DismissibleList(props) {
  const {
    data,
    labelSelector,
    keySelector,
    onChange,
    value,
    name,
    disabled,
    readOnly,
    className,
    rendererClassName
  } = props;
  const handleItemRemove = useCallback(id => {
    const newData = value === null || value === void 0 ? void 0 : value.filter(i => i !== id);
    onChange(newData ?? [], name);
  }, [value, onChange, name]);
  const rendererParams = useCallback((key, datum) => ({
    datum,
    itemKey: key,
    labelSelector,
    onRemove: handleItemRemove,
    disabled,
    readOnly,
    rendererClassName
  }), [rendererClassName, disabled, readOnly, labelSelector, handleItemRemove]);
  const selectedValues = useMemo(() => data === null || data === void 0 ? void 0 : data.filter(d => value === null || value === void 0 ? void 0 : value.includes(keySelector(d))), [data, keySelector, value]);
  return /*#__PURE__*/React.createElement(ListView, {
    className: _cs(styles.list, className),
    data: selectedValues,
    keySelector: keySelector,
    renderer: ListItem,
    spacing: "none",
    filtered: false,
    pending: false,
    errored: false,
    rendererParams: rendererParams
  });
}

var DismissibleList$1 = genericMemo(DismissibleList);

export { DismissibleList$1 as default };
//# sourceMappingURL=index.js.map
